<template>
  <v-app>
    <v-toolbar dark color="primary">
      <v-toolbar-title class="headline">
        <span>Schechoice</span>
      </v-toolbar-title>
    </v-toolbar>

    <v-content>
      <v-container>
        <v-layout row wrap>
          <v-flex
            xs12
            md4
            :class="{
              'pr-3': $vuetify.breakpoint.mdAndUp
            }"
          >
            <v-layout column class="fill-height justify-space-between">
              <v-flex class="mb-3">
                <calendar v-model="current" :datetimes="datetimes" />
              </v-flex>
              <v-flex
                class="d-flex align-end"
                :class="{
                  'd-none': $vuetify.breakpoint.smAndDown
                }"
              >
                <recruit-banner />
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 md8>
            <time-selector
              v-model="times"
              :disabled="current == null"
              class="mb-3"
            />
            <preview-area v-model="datetimes" />
          </v-flex>
        </v-layout>
      </v-container>
      <footer-content />
    </v-content>
  </v-app>
</template>

<script>
import Calendar from "./components/Calendar";
import TimeSelector from "./components/TimeSelector";
import PreviewArea from "./components/PreviewArea";
import RecruitBanner from "./components/RecruitBanner";
import FooterContent from "./components/Footer";

export default {
  name: "App",
  components: {
    Calendar,
    TimeSelector,
    PreviewArea,
    RecruitBanner,
    FooterContent
  },
  data: () => {
    return {
      current: null,
      datetimes: {}
    };
  },
  computed: {
    times: {
      get() {
        return this.datetimes.hasOwnProperty(this.current)
          ? this.datetimes[this.current]
          : [];
      },
      set(value) {
        this.datetimes[this.current] = value;
        if (this.datetimes[this.current].length === 0) {
          delete this.datetimes[this.current];
        }
        this.datetimes = Object.assign({}, this.datetimes);
      }
    }
  }
};
</script>

<style scoped lang="scss"></style>
